import { render } from "./ResponseResultAlert.vue?vue&type=template&id=67f80104&scoped=true&ts=true"
import script from "./ResponseResultAlert.vue?vue&type=script&lang=ts"
export * from "./ResponseResultAlert.vue?vue&type=script&lang=ts"

import "./ResponseResultAlert.vue?vue&type=style&index=0&id=67f80104&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f80104"]])

export default __exports__